/* tslint:disable */
/* eslint-disable */
/**
 * Gestionale.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RazzaDTO
 */
export interface RazzaDTO {
    /**
     * 
     * @type {number}
     * @memberof RazzaDTO
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof RazzaDTO
     */
    descrizione?: string | null;
}

/**
 * Check if a given object implements the RazzaDTO interface.
 */
export function instanceOfRazzaDTO(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function RazzaDTOFromJSON(json: any): RazzaDTO {
    return RazzaDTOFromJSONTyped(json, false);
}

export function RazzaDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): RazzaDTO {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'descrizione': !exists(json, 'descrizione') ? undefined : json['descrizione'],
    };
}

export function RazzaDTOToJSON(value?: RazzaDTO | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'descrizione': value.descrizione,
    };
}

